// extracted by mini-css-extract-plugin
export default {"card":"u6-z"};